// extracted by mini-css-extract-plugin
export default {"cls1":"AppearanceForm-SyncCheckBox_cls1__nLfCl","cls2":"AppearanceForm-SyncCheckBox_cls2__3IrIy AppearanceForm-SyncCheckBox_cls1__nLfCl"};